module.exports = "../fonts/Futura-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/futura/Futura-Regular.woff
// module id = 512
// module chunks = 7